import { render, staticRenderFns } from "./SlidingModal.vue?vue&type=template&id=6a8998e2&scoped=true&"
import script from "./SlidingModal.vue?vue&type=script&lang=js&"
export * from "./SlidingModal.vue?vue&type=script&lang=js&"
import style0 from "./SlidingModal.vue?vue&type=style&index=0&id=6a8998e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8998e2",
  null
  
)

export default component.exports